import store from "../../../../store";
import edit_internal from './edit_internal.vue';

window.edit_internal =  new Vue({
    store,
    el: '#edit_internal',
    name : "edit_internal",

    created () {

    },
    components : {
        edit_internal
    },

})
